import React from 'react';
import {
  AlertTriangle,
  Edit,
  Shield,
  MessageCircle,
  Target,
  CheckCircle,
  BarChart
} from 'lucide-react';
import { QuickAction, QUICK_ACTION_CONFIG } from '../../../../services/legalAIService';

interface QuickActionsProps {
  onAction: (action: QuickAction) => void;
  disabled: boolean;
}

const ACTION_ICONS: Record<QuickAction, React.ReactNode> = {
  'review-risks': <AlertTriangle className="w-3.5 h-3.5" />,
  'improve-clarity': <Edit className="w-3.5 h-3.5" />,
  'make-gdpr-compliant': <Shield className="w-3.5 h-3.5" />,
  'simplify-language': <MessageCircle className="w-3.5 h-3.5" />,
  'negotiation-suggestions': <Target className="w-3.5 h-3.5" />,
  'check-compliance': <CheckCircle className="w-3.5 h-3.5" />,
  'compare-market-standard': <BarChart className="w-3.5 h-3.5" />
};

const ACTION_COLORS: Record<QuickAction, string> = {
  'review-risks': 'bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900/30 dark:text-red-300 dark:hover:bg-red-900/50',
  'improve-clarity': 'bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:hover:bg-blue-900/50',
  'make-gdpr-compliant': 'bg-green-100 text-green-700 hover:bg-green-200 dark:bg-green-900/30 dark:text-green-300 dark:hover:bg-green-900/50',
  'simplify-language': 'bg-purple-100 text-purple-700 hover:bg-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:hover:bg-purple-900/50',
  'negotiation-suggestions': 'bg-orange-100 text-orange-700 hover:bg-orange-200 dark:bg-orange-900/30 dark:text-orange-300 dark:hover:bg-orange-900/50',
  'check-compliance': 'bg-teal-100 text-teal-700 hover:bg-teal-200 dark:bg-teal-900/30 dark:text-teal-300 dark:hover:bg-teal-900/50',
  'compare-market-standard': 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'
};

export const QuickActions: React.FC<QuickActionsProps> = ({ onAction, disabled }) => {
  const actions: QuickAction[] = [
    'review-risks',
    'improve-clarity',
    'make-gdpr-compliant',
    'simplify-language',
    'negotiation-suggestions'
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-1">Quick:</span>
      {actions.map((action) => (
        <button
          key={action}
          onClick={() => onAction(action)}
          disabled={disabled}
          className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${ACTION_COLORS[action]}`}
          title={QUICK_ACTION_CONFIG[action].description}
        >
          {ACTION_ICONS[action]}
          {QUICK_ACTION_CONFIG[action].label}
        </button>
      ))}
    </div>
  );
};

export default QuickActions;
